<template>
  <kendo-window
      ref="kendoWindowRef"
      :title="'발송 일괄 업로드'"
      :modal="true"
      :width="'500px'"
      style="display:none;"
      @close="onClickClose"
  >
    <template>
      <div class="pop-container">
        <div class="pop-conts">
          <ul>
            <li class="mgt10">
                <span>1. <b>샘플 파일을 다운로드</b> 후 내용을 입력 후 <b>파일을 업로드</b> 해 주세요.
                <br>2. 양식에 맞지않는 파일인 경우 정상 진행되지 않습니다.
                <br>3. 정상 등록되지 않은 항목은 다운로드가 가능하며 수정 후 재등록 해 주세요 </span>
                <div class="box_flex mgt10">
                <button type="button" class="mid_btn mr5 w30" @click="sampleDownload('01')" ><span><span class="k-icon k-i-download"></span>등기 샘플 파일</span></button>
                <button type="button" class="mid_btn mr5 w30" @click="sampleDownload('02')" ><span><span class="k-icon k-i-download"></span>택배 샘플 파일</span></button>
                <button type="button" class="mid_btn w35" @click="sampleDownload('03')" ><span><span class="k-icon k-i-download"></span>해외특송 샘플 파일</span></button>
                </div>
                <!-- <br><p style="color:#fe5f40;font-weight:400" class="mgt10 fl">* 발송 업로드 입니다.</p> -->
            </li>
          </ul>
          <div class="messagepop_form_wrap mgt20">
            <div class="mp_form">
              <dd>
                <kendo-upload
                    ref="upload"
                    name="files"
                    :select="fnOnSelectFile"
                    :multiple="false"
                    :files="file"
                    :localization-select="'파일 업로드'"
                    :show-file-list="true"
                    :async-auto-upload="false"
                    :validation-allowed-extensions='[".xlsx", ".xls"]'
                    style="'width: 300px;'">
                </kendo-upload>
              </dd>
            </div>
          </div>
          <div class="msg_green mgt10">
            <span v-if="isReadyToUpload">양식에 맞는 파일입니다.  중복 및 오류는 업로드  이후 확인이 가능합니다</span>
          </div>
          <div class="k-text-center mgt30">
            <button type="button" id="buttonUpload" class="mid_btn orange mr5" @click="fnExecUpload">업로드</button>
            <button type="button" id="buttonCancel" class="mid_btn" @click="$refs.kendoWindowRef.kendoWidget().close();">취소</button>
          </div>
        </div>
      </div>
    </template>
    <excel-upload-result-window
        ref="excelUploadResultWindowRef"
        :sendScn="sendScn"
        :data="excelUploadResult"
        :file="workbookData"
        @onChange="$emit('onChange')"
    >
    </excel-upload-result-window>
  </kendo-window>
</template>

<script>
import ApiConfig from '@/api/api.config'
import ApiUtil from "@/api/api.util";

import EtnersCommonUtil from '@/common/etners.common.util'
import $ from 'jquery'
import * as XLSX from "xlsx"
import EtnersLogisticsUtil from '@/common/etners.logistics.util'
import ExcelUploadResultWindow from '@/components/send/ExcelUploadResultWindow.vue'
import app from '@/main';

export default {
  name: 'receiveExcelUploadWindow',
  components: { ExcelUploadResultWindow },
  methods: {
    fnOnSelectFile (e) {
      const vm = this
      const fileInfo = e.files[0]
      vm.uploadDataArray = []

      app.$Progress.plus()
      setTimeout(function() {
        const raw = fileInfo.rawFile
        const reader = new FileReader()
        const fileList = e.sender._module.element.find('ul')
        reader.onloadend = function(e) {
          let data = e.target.result
          let workbook = XLSX.read(data, {
            type: 'binary'
          })

          vm.isSuccess = true // 초기화
          vm.workbookData = workbook
          workbook.SheetNames.forEach((sheetName) => {
            if (sheetName === '발송(등기) 양식') {
              vm.sendScn = '01'
              const rowJson = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName])
              vm.uploadDataArray = vm.regiValidCheck(rowJson)

            } else if (sheetName === '발송(국내택배) 양식') {
              vm.sendScn = '02'
              const rowJson = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName])
              vm.uploadDataArray = vm.deliValidCheck(rowJson)

            } else if (sheetName === '발송(해외특송) 양식') {
              vm.sendScn = '03'
              const rowJson = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName])
              vm.uploadDataArray = vm.exprValidCheck(rowJson)

            }
            // 업로드 실패시 array 및 fileList 제거
            if (vm.isSuccess === false) {
              vm.removeFileList(fileList)
              app.$Progress.minus()
            }
          })
          //엑셀 양식이 다른 case(시트에 진입 x)
          if (vm.isSuccess === true && vm.uploadDataArray.length === 0) {
            app.$Progress.minus()
            kendo.alert('샘플 엑셀양식과 다른 엑셀 파일입니다. 파일을 확인해주세요.')
            vm.removeFileList(fileList)
            return false
          } else if (vm.isSuccess === true) {
            // 업로드 가능 상태
            vm.isReadyToUpload = true
            app.$Progress.minus()
          }
        }
        reader.readAsBinaryString(raw)
      })
    },
    regiValidCheck (rowJson) {
      const vm = this
      if (rowJson.length < 5) {
        vm.isSuccess = false
        kendo.alert('데이터가 존재하지 않습니다.')
        return false
      }
      if (rowJson.length >= 1004) {
        vm.isSuccess = false
        kendo.alert('1000건 이상은 업데이트 할 수 없습니다.')
        return false
      }

      // 22개 열
      for (let i = 4; i < rowJson.length; i++) {
        if (rowJson[i]['_EMPTY_1'] === undefined) {
          let ppsScn = rowJson[i]['용도']
          let blNo = rowJson[i]['운송장 번호']
          let branchArea = rowJson[i]['사업장 / 거점']
          let sendDept = rowJson[i]['발신 부서']
          let sendNm = rowJson[i]['발신']
          let sendTel = rowJson[i]['전화 번호']
          let sendSabun = rowJson[i]['사원 번호']
          let sendMailAddr = rowJson[i]['이메일']
          let steadYn = rowJson[i]['대리 발송']
          let steadNm = rowJson[i]['대리 발송인']
          let steadDept = rowJson[i]['발송인 부서']
          let receiveNm = rowJson[i]['수신']
          let receiveTel = rowJson[i]['수신 연락처']
          let receivePost = rowJson[i]['수신 우편번호']
          let receiveAddr = rowJson[i]['수신 주소']
          let receiveAddrDtl = rowJson[i]['상세 주소']
          let deliveryScn = rowJson[i]['발송 수단']
          let contentsScn = rowJson[i]['내용물']
          let contentsScnDesc = rowJson[i]['내용물 상세']
          let regCost = rowJson[i]['신고 금액']
          let lockerId = rowJson[i]['보관 위치']
          let contents = rowJson[i]['비고']

          // 최종 입력 값
          const inputObj = {
            ppsScn: EtnersCommonUtil.isNotEmpty(ppsScn) ? ppsScn.toString().trim().substring(0, 2) : '',
            blNo: EtnersCommonUtil.isNotEmpty(blNo) ? blNo.toString().trim() : '',
            facility: EtnersCommonUtil.isNotEmpty(branchArea) ? branchArea.toString().trim().substring(0, 2) : '',
            area: EtnersCommonUtil.isNotEmpty(branchArea) ? branchArea.toString().trim().substring(0, 4) : '',
            sendDept: EtnersCommonUtil.isNotEmpty(sendDept) ? sendDept.toString().trim() : '',
            sendNm: EtnersCommonUtil.isNotEmpty(sendNm) ? sendNm.toString().trim() : '',
            sendTel: EtnersCommonUtil.isNotEmpty(sendTel) ? sendTel.toString().replace(/-/gi, "").trim() : '',
            sendSabun: EtnersCommonUtil.isNotEmpty(sendSabun) ? sendSabun.toString().trim() : '',
            sendMailAddr: EtnersCommonUtil.isNotEmpty(sendMailAddr) ? sendMailAddr.toString().trim() : '',
            steadYn: EtnersCommonUtil.isNotEmpty(steadYn) ? steadYn.toString().trim().substring(3, 5) : '',
            steadNm: EtnersCommonUtil.isNotEmpty(steadNm) ? steadNm.toString().trim() : '',
            steadDept: EtnersCommonUtil.isNotEmpty(steadDept) ? steadDept.toString().trim() : '',
            receiveNm: EtnersCommonUtil.isNotEmpty(receiveNm) ? receiveNm.toString().trim() : '',
            receiveTel: EtnersCommonUtil.isNotEmpty(receiveTel) ? receiveTel.toString().replace(/-/gi, "").trim() : '',
            receivePost: EtnersCommonUtil.isNotEmpty(receivePost) ? receivePost.toString().trim() : '',
            receiveAddr: EtnersCommonUtil.isNotEmpty(receiveAddr) ? receiveAddr.toString().trim() : '',
            receiveAddrDtl: EtnersCommonUtil.isNotEmpty(receiveAddrDtl) ? receiveAddrDtl.toString().trim() : '',
            deliveryScn: EtnersCommonUtil.isNotEmpty(deliveryScn) ? deliveryScn.toString().trim().substring(0, 2) : '',
            contentsScn: EtnersCommonUtil.isNotEmpty(contentsScn) ? contentsScn.toString().trim().substring(0, 2) : '',
            contentsScnDesc: EtnersCommonUtil.isNotEmpty(contentsScnDesc) ? contentsScnDesc.toString().trim() : '',
            regCost: EtnersCommonUtil.isNotEmpty(regCost) ? regCost.toString().trim() : '',
            lockerId: EtnersCommonUtil.isNotEmpty(lockerId) ? lockerId.toString().trim().substring(0, 2).padStart(5, '0') : '',
            contents: EtnersCommonUtil.isNotEmpty(contents) ? contents.toString().trim() : '',
          }

          const excelLineMessage = '<br>엑셀 줄번호(' + (i + 2) + ') : '

          // 필수값 체크
          if (EtnersCommonUtil.isEmpty(inputObj.ppsScn)) {
            kendo.alert(excelLineMessage + '용도를 선택 해주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isNotEmpty(inputObj.blNo)) {
            if (!EtnersCommonUtil.isBlNo(inputObj.blNo)) {
              kendo.alert(excelLineMessage + '운송장 번호는 영어와 숫자만 입력 해주세요.')
              vm.isSuccess = false
              return
            } else if (inputObj.blNo.length > 50) {
              kendo.alert(excelLineMessage + '운송장 번호는 50자 이내로 입력 해주세요.')
              vm.isSuccess = false
              return
            }
          }
          if (EtnersCommonUtil.isEmpty(inputObj.facility)) {
            kendo.alert(excelLineMessage + '사업장 / 거점을 선택 해주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isEmpty(inputObj.area)) {
            kendo.alert(excelLineMessage + '사업장 / 거점을 선택 해주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isEmpty(inputObj.sendDept)) {
            kendo.alert(excelLineMessage + '발신 부서를 입력 해주세요.')
            vm.isSuccess = false
            return
          } else if (inputObj.sendDept.length > 50) {
            kendo.alert(excelLineMessage + '발신 부서는 50자 이내로 입력 해주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isEmpty(inputObj.sendNm)) {
            kendo.alert(excelLineMessage + '발신을 입력 해주세요.')
            vm.isSuccess = false
            return
          } else if (inputObj.sendNm.length > 20) {
            kendo.alert(excelLineMessage + '발신은 20자 이내로 입력 해주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isEmpty(inputObj.sendTel)) {
            kendo.alert(excelLineMessage + '전화 번호를 입력 해주세요.')
            vm.isSuccess = false
            return
          } else if (EtnersCommonUtil.isNotEmpty(inputObj.sendTel) && !EtnersLogisticsUtil.isTelNum(inputObj.sendTel)) {
            kendo.alert(excelLineMessage + '전화 번호를 형식에 맞게 입력 해주세요.')
            vm.isSuccess = false
            return
          } else if (inputObj.sendTel.length > 20) {
            kendo.alert(excelLineMessage + '전화 번호는 20자 이내로 입력 해주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isEmpty(inputObj.sendSabun)) {
            kendo.alert(excelLineMessage + '사원 번호를 입력 해주세요.')
            vm.isSuccess = false
            return
          } else if (inputObj.sendSabun.length > 20) {
            kendo.alert(excelLineMessage + '사원 번호는 20자 이내로 입력 해주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isNotEmpty(inputObj.sendMailAddr) && !EtnersLogisticsUtil.isEmailDomainAllowed(inputObj.sendMailAddr)) {
            kendo.alert(excelLineMessage + EtnersLogisticsUtil.getEmailDomainAllowedMsg(""))
            vm.isSuccess = false
            return
          } else if (inputObj.sendMailAddr.length > 50) {
            kendo.alert(excelLineMessage + '이메일은 50자 이내로 입력 해주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isEmpty(inputObj.steadYn)) {
            kendo.alert(excelLineMessage + '대리 발송을 입력 해주세요.')
            vm.isSuccess = false
            return
          } else if (inputObj.steadYn === 'Y'){
            if (EtnersCommonUtil.isEmpty(inputObj.steadNm)) {
              kendo.alert(excelLineMessage + '대리 발송인을 입력 해주세요.')
              vm.isSuccess = false
              return
            } else if (inputObj.steadNm.length > 20) {
              kendo.alert(excelLineMessage + '대리 발송인은 20자 이내로 입력 해주세요.')
              vm.isSuccess = false
              return
            }
            if (EtnersCommonUtil.isEmpty(inputObj.steadDept)) {
              kendo.alert(excelLineMessage + '발송인 부서를 입력 해주세요.')
              vm.isSuccess = false
              return
            } else if (inputObj.steadDept.length > 50) {
              kendo.alert(excelLineMessage + '발송인 부서는 50자 이내로 입력 해주세요.')
              vm.isSuccess = false
              return
            }
          }
          if (EtnersCommonUtil.isEmpty(inputObj.receiveNm)) {
            kendo.alert(excelLineMessage + '수신을 입력 해주세요.')
            vm.isSuccess = false
            return
          } else if (inputObj.receiveNm.length > 20) {
            kendo.alert(excelLineMessage + '수신은 20자 이내로 입력 해주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isEmpty(inputObj.receiveTel)) {
            kendo.alert(excelLineMessage + '수신 연락처를 입력 해주세요.')
            vm.isSuccess = false
            return
          } else if (EtnersCommonUtil.isNotEmpty(inputObj.receiveTel) && !EtnersLogisticsUtil.isTelNum(inputObj.receiveTel)) {
            kendo.alert(excelLineMessage + '수신 연락처를 형식에 맞게 입력 해주세요.')
            vm.isSuccess = false
            return
          } else if (inputObj.receiveTel.length > 20) {
            kendo.alert(excelLineMessage + '수신 연락처는 20자 이내로 입력 해주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isEmpty(inputObj.receivePost)) {
            kendo.alert(excelLineMessage + '수신 우편번호를 입력 해주세요.')
            vm.isSuccess = false
            return
          } else if (inputObj.receivePost.length > 10) {
            kendo.alert(excelLineMessage + '수신 우편번호는 10자 이내로 입력 해주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isEmpty(inputObj.receiveAddr)) {
            kendo.alert(excelLineMessage + '수신 주소를 입력 해주세요.')
            vm.isSuccess = false
            return
          } else if (inputObj.receiveAddr.length > 100) {
            kendo.alert(excelLineMessage + '수신 주소는 100자 이내로 입력 해주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isEmpty(inputObj.receiveAddrDtl)) {
            kendo.alert(excelLineMessage + '상세 주소를 입력 해주세요.')
            vm.isSuccess = false
            return
          } else if (inputObj.receiveAddrDtl.length > 100) {
            kendo.alert(excelLineMessage + '상세 주소는 100자 이내로 입력 해주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isEmpty(inputObj.deliveryScn)) {
            kendo.alert(excelLineMessage + '발송 수단을 선택 해주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isEmpty(inputObj.contentsScn)) {
            kendo.alert(excelLineMessage + '내용물을 선택 해주세요.')
            vm.isSuccess = false
            return
          } else if (inputObj.contentsScn === '03') {
            if (EtnersCommonUtil.isEmpty(inputObj.contentsScnDesc)) {
              kendo.alert(excelLineMessage + '내용물 상세를 입력 해주세요.')
              vm.isSuccess = false
              return
            } else if (inputObj.contentsScnDesc.length > 100) {
              kendo.alert(excelLineMessage + '내용물 상세는 100자 이내로 입력 해주세요.')
              vm.isSuccess = false
              return
            }
          }
          if (EtnersCommonUtil.isNotEmpty(inputObj.regCost)) {
            if (!EtnersCommonUtil.isPositiveInteger(inputObj.regCost)) {
              kendo.alert(excelLineMessage + '신고 금액은 1이상의 숫자를 입력 해주세요.')
              vm.isSuccess = false
              return
            } else if (inputObj.regCost.length > 10) {
              kendo.alert(excelLineMessage + '신고 금액은 10자리 이내로 입력 해주세요.')
              vm.isSuccess = false
              return
            }
          }
          if (EtnersCommonUtil.isEmpty(inputObj.lockerId)) {
            kendo.alert(excelLineMessage + '보관 위치를 선택 해주세요.')
            vm.isSuccess = false
            return
          }

          vm.uploadDataArray.push(inputObj)
        }
      }
      return vm.uploadDataArray
    },
    deliValidCheck (rowJson) {
      const vm = this
      if (rowJson.length < 5) {
        vm.isSuccess = false
        kendo.alert('데이터가 존재하지 않습니다.')
        return false
      }
      if (rowJson.length >= 1004) {
        vm.isSuccess = false
        kendo.alert('1000건 이상은 업데이트 할 수 없습니다.')
        return false
      }

      // 20개 열
      for (let i = 4; i < rowJson.length; i++) {
        if (rowJson[i]['_EMPTY_1'] === undefined) {
          let branchArea = rowJson[i]['사업장 / 거점']
          let sendDept = rowJson[i]['발신 부서']
          let sendNm = rowJson[i]['발신']
          let sendTel = rowJson[i]['전화 번호']
          let sendSabun = rowJson[i]['사원 번호']
          let sendMailAddr = rowJson[i]['이메일']
          let steadYn = rowJson[i]['대리 발송']
          let steadNm = rowJson[i]['대리 발송인']
          let steadDept = rowJson[i]['발송인 부서']
          let receiveNm = rowJson[i]['수신']
          let receivePost = rowJson[i]['수신 우편번호']
          let receiveAddr = rowJson[i]['수신 주소']
          let receiveAddrDtl = rowJson[i]['상세 주소']
          let receiveTel = rowJson[i]['수신 연락처']
          let weight = rowJson[i]['무게']
          let itemNm = rowJson[i]['물품명']
          let regCost = rowJson[i]['신고 금액']
          let qty = rowJson[i]['수량']
          let lockerId = rowJson[i]['보관 위치']
          let contents = rowJson[i]['비고']

          // 최종 입력 값
          const inputObj = {
            facility: EtnersCommonUtil.isNotEmpty(branchArea) ? branchArea.toString().trim().substring(0, 2) : '',
            area: EtnersCommonUtil.isNotEmpty(branchArea) ? branchArea.toString().trim().substring(0, 4) : '',
            sendDept: EtnersCommonUtil.isNotEmpty(sendDept) ? sendDept.toString().trim() : '',
            sendNm: EtnersCommonUtil.isNotEmpty(sendNm) ? sendNm.toString().trim() : '',
            sendTel: EtnersCommonUtil.isNotEmpty(sendTel) ? sendTel.toString().replace(/-/gi, "").trim() : '',
            sendSabun: EtnersCommonUtil.isNotEmpty(sendSabun) ? sendSabun.toString().trim() : '',
            sendMailAddr: EtnersCommonUtil.isNotEmpty(sendMailAddr) ? sendMailAddr.toString().trim() : '',
            steadYn: EtnersCommonUtil.isNotEmpty(steadYn) ? steadYn.toString().trim().substring(3, 5) : '',
            steadNm: EtnersCommonUtil.isNotEmpty(steadNm) ? steadNm.toString().trim() : '',
            steadDept: EtnersCommonUtil.isNotEmpty(steadDept) ? steadDept.toString().trim() : '',
            receiveNm: EtnersCommonUtil.isNotEmpty(receiveNm) ? receiveNm.toString().trim() : '',
            receivePost: EtnersCommonUtil.isNotEmpty(receivePost) ? receivePost.toString().trim() : '',
            receiveAddr: EtnersCommonUtil.isNotEmpty(receiveAddr) ? receiveAddr.toString().trim() : '',
            receiveAddrDtl: EtnersCommonUtil.isNotEmpty(receiveAddrDtl) ? receiveAddrDtl.toString().trim() : '',
            receiveTel: EtnersCommonUtil.isNotEmpty(receiveTel) ? receiveTel.toString().replace(/-/gi, "").trim() : '',
            weight: EtnersCommonUtil.isNotEmpty(weight) ? weight.toString().trim() : '',
            itemNm: EtnersCommonUtil.isNotEmpty(itemNm) ? itemNm.toString().trim() : '',
            regCost: EtnersCommonUtil.isNotEmpty(regCost) ? regCost.toString().trim() : '',
            qty: EtnersCommonUtil.isNotEmpty(qty) ? qty.toString().trim() : '',
            lockerId: EtnersCommonUtil.isNotEmpty(lockerId) ? lockerId.toString().trim().substring(0, 2).padStart(5, '0') : '',
            contents: EtnersCommonUtil.isNotEmpty(contents) ? contents.toString().trim() : '',
          }

          const excelLineMessage = '<br>엑셀 줄번호(' + (i + 2) + ') : '

          // 필수값 체크
          if (EtnersCommonUtil.isEmpty(inputObj.facility)) {
            kendo.alert(excelLineMessage + '사업장 / 거점을 선택 해주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isEmpty(inputObj.area)) {
            kendo.alert(excelLineMessage + '사업장 / 거점을 선택 해주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isEmpty(inputObj.sendDept)) {
            kendo.alert(excelLineMessage + '발신 부서를 입력 해주세요.')
            vm.isSuccess = false
            return
          } else if (inputObj.sendDept.length > 50) {
            kendo.alert(excelLineMessage + '발신 부서는 50자 이내로 입력 해주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isEmpty(inputObj.sendNm)) {
            kendo.alert(excelLineMessage + '발신을 입력 해주세요.')
            vm.isSuccess = false
            return
          } else if (inputObj.sendNm.length > 20) {
            kendo.alert(excelLineMessage + '발신은 20자 이내로 입력 해주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isEmpty(inputObj.sendTel)) {
            kendo.alert(excelLineMessage + '전화 번호를 입력 해주세요.')
            vm.isSuccess = false
            return
          } else if (EtnersCommonUtil.isNotEmpty(inputObj.sendTel) && !EtnersLogisticsUtil.isTelNum(inputObj.sendTel)) {
            kendo.alert(excelLineMessage + '전화 번호를 형식에 맞게 입력해 주세요.')
            vm.isSuccess = false
            return
          } else if (inputObj.sendTel.length > 20) {
            kendo.alert(excelLineMessage + '전화 번호는 20자 이내로 입력해 주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isEmpty(inputObj.sendSabun)) {
            kendo.alert(excelLineMessage + '사원 번호를 입력 해주세요.')
            vm.isSuccess = false
            return
          } else if (inputObj.sendSabun.length > 20) {
            kendo.alert(excelLineMessage + '사원 번호는 20자 이내로 입력 해주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isEmpty(inputObj.sendMailAddr)) {
            kendo.alert(excelLineMessage + '이메일을 입력 해주세요.')
            vm.isSuccess = false
            return
          } else if (EtnersCommonUtil.isNotEmpty(inputObj.sendMailAddr) && !EtnersLogisticsUtil.isEmailDomainAllowed(inputObj.sendMailAddr)) {
            kendo.alert(excelLineMessage + EtnersLogisticsUtil.getEmailDomainAllowedMsg(""))
            vm.isSuccess = false
            return
          } else if (inputObj.sendMailAddr.length > 50) {
            kendo.alert(excelLineMessage + '이메일은 50자 이내로 입력 해주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isEmpty(inputObj.steadYn)) {
            kendo.alert(excelLineMessage + '대리 발송을 입력 해주세요.')
            vm.isSuccess = false
            return
          } else if (inputObj.steadYn === 'Y'){
            if (EtnersCommonUtil.isEmpty(inputObj.steadNm)) {
              kendo.alert(excelLineMessage + '대리 발송인을 입력 해주세요.')
              vm.isSuccess = false
              return
            } else if (inputObj.steadNm.length > 20) {
              kendo.alert(excelLineMessage + '대리 발송인은 20자 이내로 입력 해주세요.')
              vm.isSuccess = false
              return
            }
            if (EtnersCommonUtil.isEmpty(inputObj.steadDept)) {
              kendo.alert(excelLineMessage + '발송인 부서를 입력 해주세요.')
              vm.isSuccess = false
              return
            } else if (inputObj.steadDept.length > 50) {
              kendo.alert(excelLineMessage + '발송인 부서는 50자 이내로 입력 해주세요.')
              vm.isSuccess = false
              return
            }
          }
          if (EtnersCommonUtil.isEmpty(inputObj.receiveNm)) {
            kendo.alert(excelLineMessage + '수신을 입력 해주세요.')
            vm.isSuccess = false
            return
          } else if (inputObj.receiveNm.length > 20) {
            kendo.alert(excelLineMessage + '수신은 20자 이내로 입력 해주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isEmpty(inputObj.receivePost)) {
            kendo.alert(excelLineMessage + '수신 우편번호를 입력 해주세요.')
            vm.isSuccess = false
            return
          } else if (inputObj.receivePost.length > 10) {
            kendo.alert(excelLineMessage + '수신 우편번호는 10자 이내로 입력 해주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isEmpty(inputObj.receiveAddr)) {
            kendo.alert(excelLineMessage + '수신 주소를 입력 해주세요.')
            vm.isSuccess = false
            return
          } else if (inputObj.receiveAddr.length > 100) {
            kendo.alert(excelLineMessage + '수신 주소는 100자 이내로 입력 해주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isEmpty(inputObj.receiveAddrDtl)) {
            kendo.alert(excelLineMessage + '상세 주소를 입력 해주세요.')
            vm.isSuccess = false
            return
          } else if (inputObj.receiveAddrDtl.length > 100) {
            kendo.alert(excelLineMessage + '상세 주소는 100자 이내로 입력 해주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isEmpty(inputObj.receiveTel)) {
            kendo.alert(excelLineMessage + '수신 연락처를 입력 해주세요.')
            vm.isSuccess = false
            return
          } else if (EtnersCommonUtil.isNotEmpty(inputObj.receiveTel) && !EtnersLogisticsUtil.isTelNum(inputObj.receiveTel)) {
            kendo.alert(excelLineMessage + '수신 연락처를 형식에 맞게 입력해 주세요.')
            vm.isSuccess = false
            return
          } else if (inputObj.receiveTel.length > 20) {
            kendo.alert(excelLineMessage + '수신 연락처는 20자 이내로 입력해 주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isEmpty(inputObj.weight)) {
            kendo.alert(excelLineMessage + '무게를 입력 해주세요.')
            vm.isSuccess = false
            return
          } else if (EtnersCommonUtil.isNotEmpty(inputObj.weight) && !EtnersLogisticsUtil.isPositiveInteger(inputObj.weight)){
            kendo.alert(excelLineMessage + '무게는 1이상의 숫자를 입력 해주세요.')
            vm.isSuccess = false
            return
          } else if (inputObj.weight.length > 2) {
            kendo.alert(excelLineMessage + '무게는 2자 이내로 입력 해주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isEmpty(inputObj.itemNm)) {
            kendo.alert(excelLineMessage + '물품명을 입력 해주세요.')
            vm.isSuccess = false
            return
          } else if (inputObj.itemNm.length > 50) {
            kendo.alert(excelLineMessage + '물품명은 50자 이내로 입력 해주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isEmpty(inputObj.regCost)) {
            kendo.alert(excelLineMessage + '신고 금액을 입력 해주세요.')
            vm.isSuccess = false
            return
          } else if (inputObj.regCost !== '0' || EtnersCommonUtil.isNotEmpty(inputObj.regCost)) {
            if (!EtnersCommonUtil.isPositiveInteger(inputObj.regCost)) {
              kendo.alert(excelLineMessage + '신고 금액은 1이상의 숫자를 입력 해주세요.')
              vm.isSuccess = false
              return
            }
          } else if (inputObj.regCost.length > 10) {
            kendo.alert(excelLineMessage + '신고 금액은 10자 이내로 입력 해주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isEmpty(inputObj.lockerId)) {
            kendo.alert(excelLineMessage + '보관 위치를 선택 해주세요.')
            vm.isSuccess = false
            return
          }

          vm.uploadDataArray.push(inputObj)
        }
      }
      return vm.uploadDataArray
    },
    exprValidCheck (rowJson) {
      const vm = this
      if (rowJson.length < 5) {
        vm.isSuccess = false
        kendo.alert('데이터가 존재하지 않습니다.')
        return false
      }
      if (rowJson.length >= 1004) {
        vm.isSuccess = false
        kendo.alert('1000건 이상은 업데이트 할 수 없습니다.')
        return false
      }

      // 15개 열
      for (let i = 4; i < rowJson.length; i++) {
        if (rowJson[i]['_EMPTY_1'] === undefined) {
          let shpcScn = rowJson[i]['특송사']
          let blNo = rowJson[i]['운송장 번호']
          let branchArea = rowJson[i]['사업장 / 거점']
          let sendDept = rowJson[i]['발신 부서']
          let sendNm = rowJson[i]['발신']
          let sendTel = rowJson[i]['전화 번호']
          let sendSabun = rowJson[i]['사원 번호']
          let sendMailAddr = rowJson[i]['이메일']
          let steadYn = rowJson[i]['대리 발송']
          let steadNm = rowJson[i]['대리 발송인']
          let steadDept = rowJson[i]['발송인 부서']
          let woodenYn = rowJson[i]['우든 포장 추가']
          let qty = rowJson[i]['수량']
          let lockerId = rowJson[i]['보관 위치']
          let contents = rowJson[i]['비고']

          // 최종 입력 값
          const inputObj = {
            shpcScn: EtnersCommonUtil.isNotEmpty(shpcScn) ? shpcScn.toString().trim().substring(0, 2) : '',
            blNo: EtnersCommonUtil.isNotEmpty(blNo) ? blNo.toString().trim() : '',
            facility: EtnersCommonUtil.isNotEmpty(branchArea) ? branchArea.toString().trim().substring(0, 2) : '',
            area: EtnersCommonUtil.isNotEmpty(branchArea) ? branchArea.toString().trim().substring(0, 4) : '',
            sendDept: EtnersCommonUtil.isNotEmpty(sendDept) ? sendDept.toString().trim() : '',
            sendNm: EtnersCommonUtil.isNotEmpty(sendNm) ? sendNm.toString().trim() : '',
            sendTel: EtnersCommonUtil.isNotEmpty(sendTel) ? sendTel.toString().replace(/-/gi, "").trim() : '',
            sendSabun: EtnersCommonUtil.isNotEmpty(sendSabun) ? sendSabun.toString().trim() : '',
            sendMailAddr: EtnersCommonUtil.isNotEmpty(sendMailAddr) ? sendMailAddr.toString().trim() : '',
            steadYn: EtnersCommonUtil.isNotEmpty(steadYn) ? steadYn.toString().trim().substring(3, 5) : '',
            steadNm: EtnersCommonUtil.isNotEmpty(steadNm) ? steadNm.toString().trim() : '',
            steadDept: EtnersCommonUtil.isNotEmpty(steadDept) ? steadDept.toString().trim() : '',
            woodenYn: EtnersCommonUtil.isNotEmpty(woodenYn) ? woodenYn.toString().trim().substring(3, 5) : '',
            qty: EtnersCommonUtil.isNotEmpty(qty) ? qty.toString().trim() : '',
            lockerId: EtnersCommonUtil.isNotEmpty(lockerId) ? lockerId.toString().trim().substring(0, 2).padStart(5, '0') : '',
            contents: EtnersCommonUtil.isNotEmpty(contents) ? contents.toString().trim() : '',
          }

          const excelLineMessage = '<br>엑셀 줄번호(' + (i + 2) + ') : '

          // 필수값 체크
          if (EtnersCommonUtil.isEmpty(inputObj.shpcScn)) {
            kendo.alert(excelLineMessage + '특송사를 선택 해주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isEmpty(inputObj.blNo)) {
            kendo.alert(excelLineMessage + '운송장 번호를 입력 해주세요.')
            vm.isSuccess = false
            return
          } else if (inputObj.blNo.length > 50) {
            kendo.alert(excelLineMessage + '운송장 번호는 50자 이내로 입력 해주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isEmpty(inputObj.facility)) {
            kendo.alert(excelLineMessage + '사업장 / 거점을 선택 해주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isEmpty(inputObj.area)) {
            kendo.alert(excelLineMessage + '사업장 / 거점을 선택 해주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isEmpty(inputObj.sendDept)) {
            kendo.alert(excelLineMessage + '발신 부서를 입력 해주세요.')
            vm.isSuccess = false
            return
          } else if (inputObj.sendDept.length > 50) {
            kendo.alert(excelLineMessage + '발신 부서는 50자 이내로 입력 해주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isEmpty(inputObj.sendNm)) {
            kendo.alert(excelLineMessage + '발신을 입력 해주세요.')
            vm.isSuccess = false
            return
          } else if (inputObj.sendNm.length > 20) {
            kendo.alert(excelLineMessage + '발신은 20자 이내로 입력 해주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isEmpty(inputObj.sendTel)) {
            kendo.alert(excelLineMessage + '전화 번호를 입력 해주세요.')
            vm.isSuccess = false
            return
          } else if (EtnersCommonUtil.isNotEmpty(inputObj.sendTel) && !EtnersLogisticsUtil.isTelNum(inputObj.sendTel)) {
            kendo.alert(excelLineMessage + '전화 번호를 형식에 맞게 입력해 주세요.')
            vm.isSuccess = false
            return
          } else if (inputObj.sendTel.length > 20) {
            kendo.alert(excelLineMessage + '전화 번호는 20자 이내로 입력해 주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isEmpty(inputObj.sendSabun)) {
            kendo.alert(excelLineMessage + '사원 번호를 입력 해주세요.')
            vm.isSuccess = false
            return
          } else if (inputObj.sendSabun.length > 20) {
            kendo.alert(excelLineMessage + '사원 번호는 20자 이내로 입력 해주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isEmpty(inputObj.sendMailAddr)) {
            kendo.alert(excelLineMessage + '이메일을 입력 해주세요.')
            vm.isSuccess = false
            return
          } else if (EtnersCommonUtil.isNotEmpty(inputObj.sendMailAddr) && !EtnersLogisticsUtil.isEmailDomainAllowed(inputObj.sendMailAddr)) {
            kendo.alert(excelLineMessage + EtnersLogisticsUtil.getEmailDomainAllowedMsg(""))
            vm.isSuccess = false
            return
          } else if (inputObj.sendMailAddr.length > 50) {
            kendo.alert(excelLineMessage + '이메일은 50자 이내로 입력 해주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isEmpty(inputObj.steadYn)) {
            kendo.alert(excelLineMessage + '대리 발송을 입력 해주세요.')
            vm.isSuccess = false
            return
          } else if (inputObj.steadYn === 'Y'){
            if (EtnersCommonUtil.isEmpty(inputObj.steadNm)) {
              kendo.alert(excelLineMessage + '대리 발송인을 입력 해주세요.')
              vm.isSuccess = false
              return
            } else if (inputObj.steadNm.length > 20) {
              kendo.alert(excelLineMessage + '대리 발송인은 20자 이내로 입력 해주세요.')
              vm.isSuccess = false
              return
            }
            if (EtnersCommonUtil.isEmpty(inputObj.steadDept)) {
              kendo.alert(excelLineMessage + '발송인 부서를 입력 해주세요.')
              vm.isSuccess = false
              return
            } else if (inputObj.steadDept.length > 50) {
              kendo.alert(excelLineMessage + '발송인 부서는 50자 이내로 입력 해주세요.')
              vm.isSuccess = false
              return
            }
          }
          if (EtnersCommonUtil.isEmpty(inputObj.woodenYn)) {
            kendo.alert(excelLineMessage + '우든 포장 추가를 선택 해주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isEmpty(inputObj.qty)) {
            kendo.alert(excelLineMessage + '수량을 입력 해주세요.')
            vm.isSuccess = false
            return
          } else if (EtnersCommonUtil.isNotEmpty(inputObj.qty) && !EtnersCommonUtil.isPositiveInteger(inputObj.qty)) {
            kendo.alert(excelLineMessage + '수량은 1이상의 숫자를 입력 해주세요.')
            vm.isSuccess = false
            return
          } else if (inputObj.qty.length > 2) {
            kendo.alert(excelLineMessage + '수량은 2자 이내로 입력 해주세요.')
            vm.isSuccess = false
            return
          }
          if (EtnersCommonUtil.isEmpty(inputObj.lockerId)) {
            kendo.alert(excelLineMessage + '보관 위치를 선택 해주세요.')
            vm.isSuccess = false
            return
          }

          vm.uploadDataArray.push(inputObj)
        }
      }
      return vm.uploadDataArray
    },
    fnExecUpload: function(e) {
      const vm = this
      if (vm.uploadDataArray.length === 0) {
        kendo.alert('업로드한 자료가 없습니다.')
        return false
      }

      const fileList = e.target.parentNode.parentNode.querySelector('.k-upload-sync ul')
      kendo.confirm('발송 ' + vm.uploadDataArray.length + '건을 업로드 하시겠습니까?').done(function() {
        let params = {
          loginUserToken: vm.loginUserToken,
          sendScn: vm.sendScn,
          shpcScn: vm.shpcScn,
          uploadInfoList: vm.uploadDataArray,
        }
        let buttonUploadElem = document.querySelector('#buttonUpload')
        buttonUploadElem.setAttribute('disabled', 'disabled')

        // 1. 데이터 업로드 API 호출
        ApiUtil.post(`${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/sendManage/sendExcelUpload.json`, params, {isShowLoadingBar:false}).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            kendo.alert('데이터가 정상적으로 처리되지 않았습니다.')
            vm.removeFileList(fileList)
            buttonUploadElem.removeAttribute("disabled")
            return false
          }
          if (response.data.resultStatus.messageCode !== '2000') {
            kendo.alert(response.data.resultStatus.messageText)
            vm.removeFileList(fileList)
            buttonUploadElem.removeAttribute("disabled")
            return false
          }
          let resultData = response.data.resultData
          buttonUploadElem.removeAttribute("disabled")
          if(resultData.boolResult === false){
            vm.excelUploadResult = resultData
            vm.removeFileList(fileList)
            vm.$refs.kendoWindowRef.kendoWidget().close()
            vm.uploadResult()
            return false
          } else {
            vm.excelUploadResult = resultData
            vm.removeFileList(fileList)
            vm.$refs.kendoWindowRef.kendoWidget().close()
            vm.uploadResult()
          }
        })
      })
    },
    removeFileList (fileList) {
      const vm = this
      vm.uploadDataArray = []
      if (!!fileList) {
        fileList.remove()
      }
    },
    sampleDownload(sendScn){
      const vm = this
      if (sendScn === '01') {
        vm.shpcScn = '05'
        window.location = `${ApiConfig.eklDomain}/invariable/files/logistics_send_regi_excel_upload_form.xlsx`
      } else if (sendScn === '02') {
        vm.shpcScn = '04'
        window.location = `${ApiConfig.eklDomain}/invariable/files/logistics_send_deli_excel_upload_form.xlsx`
      } else if (sendScn === '03') {
        vm.shpcScn = null // 엑셀 입력값이다.
        window.location = `${ApiConfig.eklDomain}/invariable/files/logistics_send_expr_excel_upload_form.xlsx`
      }
    },
    uploadResult(){
      const vm = this
      vm.$refs.excelUploadResultWindowRef.$refs.kendoWindowRef.kendoWidget().center().open()
    },
    onClickClose () {
      const vm = this
      vm.isReadyToUpload = false
      const fileList = document.querySelector('.k-upload-sync ul')
      vm.removeFileList(fileList)
    },
  },
  data: function() {
    return {
      loginUserToken: sessionStorage.getItem('loginUserToken'),
      sendScn: '01',
      shpcScn: '05',
      file: [],
      workbookData: null,
      excelUploadResult: {},
      isSuccess: true,
      isReadyToUpload: false,
      uploadDataArray: [],
    }
  },
}
</script>
